import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { UserModule } from "../user/user.module";
import { ActionsMenuComponent } from "./components/actions-menu/actions-menu.component";
import { SideMenuComponent } from "./components/side-menu/side-menu.component";
import { TopMenuComponent } from "./components/top-menu/top-menu.component";
import { ActionsMenuService } from "./services/actionsMenu.service";
import { SideMenuService } from "./services/sideMenu.service";

import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { BreadCrumbModule } from "../breadcrumbs/breadcrumbs.module";

import { ToolbarModule } from 'primeng/toolbar';
import { MenuModule } from "primeng/menu";
import { ListboxModule } from "primeng/listbox";
import { DividerModule } from 'primeng/divider';
import { ImageModule } from 'primeng/image';
import { UserOptionsSideMenuComponent } from "./components/user-options-side-menu/user-options-side-menu.component";
import { AvatarModule } from 'primeng/avatar';
import { MenubarModule } from 'primeng/menubar';

import { FileUploadModule } from 'primeng/fileupload';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SidebarModule } from "primeng/sidebar";




@NgModule({
    imports: [
        CommonModule,
        UserModule,
        TranslateModule,
        RouterModule,
        BreadCrumbModule,
        ToolbarModule,
        MenuModule,
        ListboxModule,
        DividerModule,
        ImageModule,
        AvatarModule,
        MenubarModule,
        FileUploadModule,
        OverlayPanelModule,
        SidebarModule

    ],
    declarations: [ActionsMenuComponent, SideMenuComponent, TopMenuComponent, UserOptionsSideMenuComponent],
    exports: [
        ActionsMenuComponent,
        SideMenuComponent,
        TopMenuComponent,
        TranslateModule,
        UserOptionsSideMenuComponent
    ],
    providers: [SideMenuService, ActionsMenuService],
})
export class MenusModule { }
